import { memo } from 'react'

import { useZaiPrePromptLinkModel } from './zai-pre-prompt-link.model'
import type { TZaiPrePromptLink } from './zai-pre-prompt-link.types'
import { ZaiPrePromptLinkView } from './zai-pre-prompt-link.view'

const Component: TZaiPrePromptLink = ({ children, url, variant }) => {
  const { handleClick } = useZaiPrePromptLinkModel()

  return (
    <ZaiPrePromptLinkView url={url} variant={variant} onClickLink={handleClick}>
      {children}
    </ZaiPrePromptLinkView>
  )
}

export const ZaiPrePromptLink = memo(Component)
